import { ORDER_PROGRESS_STAGES } from '../constants/orderProgressStages';
import { LoanStatusType } from '../types/loanStatusType';
import { OrderStatusType } from '../types/orderStatusType';
import { findNonActiveApplicationStatus } from './findNonActiveApplicationStatus';
import { getLinealProgressStepsArray } from './getLinealProgressStepsArray';

export const orderStatusesMapper = (
  currentOrderStatuses?: OrderStatusType[],
  currentLoanStatuses?: LoanStatusType[],
) => {
  const mappedOrderStatuses: OrderStatusType[] = [];

  const linealProgressSteps = getLinealProgressStepsArray(ORDER_PROGRESS_STAGES);

  const loanStatusArray = currentLoanStatuses?.filter((loanStatus) =>
    linealProgressSteps.some((step) => step.status === loanStatus.status),
  ) as unknown as OrderStatusType[];

  const orderStatusArray = currentOrderStatuses?.filter((loanStatus) =>
    linealProgressSteps.some((step) => step.status === loanStatus.status),
  );

  const orderNonActiveStatus =
    currentOrderStatuses && currentOrderStatuses.length > 0
      ? findNonActiveApplicationStatus(currentOrderStatuses)
      : undefined;

  if (loanStatusArray) mappedOrderStatuses.push(...loanStatusArray);
  if (orderStatusArray) mappedOrderStatuses.push(...orderStatusArray);
  if (orderNonActiveStatus) mappedOrderStatuses.push(...[orderNonActiveStatus]);

  mappedOrderStatuses.sort((a, b) => a?.updatedAt.getTime() - b?.updatedAt.getTime());

  return mappedOrderStatuses;
};
